import { StatusBadge } from '@/components/common/StatusBadge';
import { APPROVAL_STATUS_TONE, type StatusColorTone } from '@/styles/statusColors';
import type { OfflineDcrRow } from '../types/billing.types';

type Status = OfflineDcrRow['status'];
type DecisionKind = 'verify' | 'approve';

const ACCEPTED_LABEL: Record<DecisionKind, string> = {
  verify: 'Verified',
  approve: 'Approved',
};

const PENDING_LABEL = 'Pending';
const REJECTED_LABEL = 'Rejected';

const TONE: Record<Status, StatusColorTone> = {
  pending: APPROVAL_STATUS_TONE.pending,
  accepted: APPROVAL_STATUS_TONE.approved,
  rejected: APPROVAL_STATUS_TONE.rejected,
};

interface VerifyStatusBadgeProps {
  status: Status;
  decisionKind: DecisionKind;
}

function getStatusLabel(status: Status, decisionKind: DecisionKind): string {
  if (status === 'accepted') return ACCEPTED_LABEL[decisionKind];
  if (status === 'rejected') return REJECTED_LABEL;
  return PENDING_LABEL;
}

export function VerifyStatusBadge({ status, decisionKind }: VerifyStatusBadgeProps) {
  return <StatusBadge tone={TONE[status]}>{getStatusLabel(status, decisionKind)}</StatusBadge>;
}
